import { render, staticRenderFns } from "./AverageOrderValueByPaymentPage.vue?vue&type=template&id=3d942b60&scoped=true&"
import script from "./AverageOrderValueByPaymentPage.vue?vue&type=script&lang=js&"
export * from "./AverageOrderValueByPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./AverageOrderValueByPaymentPage.vue?vue&type=style&index=0&id=3d942b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d942b60",
  null
  
)

export default component.exports